import React, { Component } from 'react'
import { Col, Row, Panel , PanelGroup } from "react-bootstrap";
import {   reduxForm, propTypes,change, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import _ from 'lodash'
import {  fetchActiveSeasons, fetchNewSeason } from "../../redux/actions/seasonActions"
import ContentWrapper from "../../components/layout/ContentWrapper"
import { isEmpty } from '../../utils/functions';
import SeasonDates from './components/SeasonDates'
import OilConditions from './components/OilConditions'
import Setup from './components/Setup'
import Divisions from './components/Divisions'
import Fees from './components/Fees'
import Participant from './components/Participant'
import Template from './components/Template'
import TriggerSeason from './components/TriggerSeason'

const formName = 'seasonsettings'

const SettingsTabs = {
    Dates:1,
    OilConditions:2,
    Setup:3,
    Divisions:4,
    Fees:5,
    Participants:6,
    Template:7,
    AthleteBio:8
}

// this is a HOC that host all other components that make up the process of setting up a season 
class SeasonSettings extends Component {
	static propTypes = {
			...propTypes
	}
	constructor(props,context) {
		super(props,context)
		this.state = {
			activeKey:-1,
			datesOpen:false,
			oilOpen:false,
			setupOpen:false,
			divisionsOpen:false,
			feesOpen:false,
			participantsOpen:false,
			templateOpen:false,
			athletebioOpen:false,
			datesSaved:true,
			oilSaved:true,
			setupSaved:true,
			divisionsSaved:true,
			feesSaved:true,
			participantsSaved:true,
			templateSaved:true,
			resetDates:false,
			resetOil:false,
			resetSetup:false,
			resetDivisions:false,
			resetFees:false,
			resetParticipants:false,
			resetTemplate:false
		}
		this.handleSelectedSeasonChanged = this.handleSelectedSeasonChanged.bind(this)
		this.handlePanelNavigation       = this.handlePanelNavigation.bind(this)
		this.checkSettingsSaved          = this.checkSettingsSaved.bind(this)
		this.settingsDataSaved           = this.settingsDataSaved.bind(this)
		this.datesResetDone              = this.datesResetDone.bind(this)        
		this.oilResetDone                = this.oilResetDone.bind(this)
		this.setupResetDone              = this.setupResetDone.bind(this)
		this.divisionsResetDone          = this.divisionsResetDone.bind(this)
		this.feesResetDone               = this.feesResetDone.bind(this)
		this.participantsResetDone       = this.participantsResetDone.bind(this)
		this.templateResetDone           = this.templateResetDone.bind(this)
		this.handleAddSeason			 = this.handleAddSeason.bind(this)
    }
    componentDidMount(){
		const { dispatch } = this.props
		dispatch(fetchActiveSeasons())
	}
	
	handleAddSeason(){
		const { dispatch } = this.props
		dispatch(fetchNewSeason());
	}

    handleSelectedSeasonChanged(seasonId,seasonyears,isSeasonSet){
			const { dispatch } = this.props
			if(isSeasonSet === true)
			{
				// update the settingsseason value
				dispatch(change(formName, 'settingsseason',seasonId));
				dispatch(change('seasonoil', 'settingsseason',seasonId));
				dispatch(change('seasonsetup', 'settingsseason',seasonId));
				dispatch(change('seasonfees', 'settingsseason',seasonId));
				dispatch(change('seasondivisions', 'settingsseason',seasonId));
				dispatch(change('seasonparticipants', 'settingsseason',seasonId));
				dispatch(change('seasontemplate', 'settingsseason',seasonId));
				dispatch(change(formName, 'seasonyears',seasonyears));
			}
			else
			{
				dispatch(change(formName, 'settingsseason',seasonId));
				dispatch(change(formName, 'seasonyears',seasonyears));
			}
    }
    handlePanelNavigation(activeKey) {       
        this.setState({ activeKey })   
        switch(activeKey){
            case SettingsTabs.Dates:{
                this.setState({ datesOpen: !this.state.datesOpen })
                break
            }
            case SettingsTabs.OilConditions:{
                this.setState({ oilOpen: !this.state.oilOpen })
                break
            }
            case SettingsTabs.Setup:{
                this.setState({ setupOpen: !this.state.setupOpen })
                break
            }
            case SettingsTabs.Divisions:{
                this.setState({ divisionsOpen: !this.state.divisionsOpen })
                break
            }
            case SettingsTabs.Fees:{
                this.setState({ feesOpen: !this.state.feesOpen })
                break
            }
            case SettingsTabs.Participants:{
                this.setState({ participantsOpen: !this.state.participantsOpen })
                break
            }  
            case SettingsTabs.Template:{
                this.setState({ templateOpen: !this.state.templateOpen })
                break
            }  
            case SettingsTabs.AthleteBio:{
                this.setState({ athletebioOpen: !this.state.athletebioOpen })
                break
            }  
        }
      
        this.checkSettingsSaved()
    }
   
    checkSettingsSaved() {       
        const { activeKey, datesOpen,oilOpen,setupOpen,divisionsOpen,feesOpen,participantsOpen,templateOpen,
                datesSaved,oilSaved,setupSaved,divisionsSaved,feesSaved,participantsSaved,templateSaved } = this.state
        const collapsed = true 
           
        switch(activeKey) {
            case SettingsTabs.Dates:{
                if(datesOpen == collapsed){
                    if(datesSaved == false){
                        this.setState({ resetDates:true })
                    }
                }    
                if(oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if(setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if(divisionsSaved == false){
                    this.setState({ resetDivisions:true })
                }
                if(feesSaved == false){
                    this.setState({ resetFees:true })
                }
                if (participantsSaved == false){
                    this.setState({ resetParticipants:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }
                break
            }
            case SettingsTabs.OilConditions:{
							if(oilOpen == collapsed){
								if(oilSaved == false){
									this.setState({ resetOil:true })
								}
							}
							if (datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(setupSaved == false){
									this.setState({ resetSetup:true })
							}
							if(divisionsSaved == false){
									this.setState({ resetDivisions:true })
							}
							if(feesSaved == false){
									this.setState({ resetFees:true })
							}
							if (participantsSaved == false){
									this.setState({ resetParticipants:true })
							}
							if(templateSaved ==  false){
									this.setState({ resetTemplate:true })
							}     
							break
            }
            case SettingsTabs.Setup:{
							if(setupOpen == collapsed){
									if(setupSaved == false){
											this.setState({ resetSetup:true })
									}
							}
							if(datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(oilSaved == false){
									this.setState({ resetOil:true })
							}
							if(divisionsSaved == false){
									this.setState({ resetDivisions:true })
							}
							if(feesSaved == false){
									this.setState({ resetFees:true })
							}
							if (participantsSaved == false){
									this.setState({ resetParticipants:true })
							}
							if(templateSaved ==  false){
									this.setState({ resetTemplate:true })
							}
							break
            }
            case SettingsTabs.Divisions:{
							if(divisionsOpen == collapsed){
									if(divisionsSaved == false){
											this.setState({ resetDivisions:true })
									}
							}
							if(datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(oilSaved == false){
									this.setState({ resetOil:true })
							}
							if(setupSaved == false){
									this.setState({ resetSetup:true })
							}
							if(feesSaved == false){
									this.setState({ resetFees:true })
							}
							if (participantsSaved == false){
									this.setState({ resetParticipants:true })
							}
							if(templateSaved ==  false){
									this.setState({ resetTemplate:true })
							}
							break
            }
            case SettingsTabs.Fees:{
							if(feesOpen == collapsed){
									if(feesSaved == false){
											this.setState({ resetFees:true })
									}
							}
							if(datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(oilSaved == false){
									this.setState({ resetOil:true })
							}
							if(setupSaved == false){
									this.setState({ resetSetup:true })
							}
							if(divisionsSaved == false){
									this.setState({ resetDivisions:true })
							}
							if (participantsSaved == false){
									this.setState({ resetParticipants:true })
							}
							if(templateSaved ==  false){
									this.setState({ resetTemplate:true })
							}
							break
            }
            case SettingsTabs.Participants:{
							if(participantsOpen == collapsed){
									if(participantsSaved == false){
											this.setState({ resetParticipants:true })
									}
							}
							if (datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(oilSaved == false){
									this.setState({ resetOil:true })
							}
							if (setupSaved == false){
									this.setState({ resetSetup:true })
							}
							if(divisionsSaved == false){
									this.setState({ resetDivisions:true })
							}
							if(feesSaved == false){
									this.setState({ resetFees:true })
							}
							if(templateSaved ==  false){
									this.setState({ resetTemplate:true })
							}
							break
            } 
            case SettingsTabs.Template:{
							if(templateOpen == collapsed){
									if(templateSaved == false){
											this.setState({ resetTemplate:true })
									}
							}
							if(datesSaved == false){
									this.setState({ resetDates:true })
							}
							if(oilSaved == false){
									this.setState({ resetOil:true })
							}
							if(setupSaved == false){
									this.setState({ resetSetup:true })
							}
							if(divisionsSaved == false){
									this.setState({ resetDivisions:true })
							}
							if(feesSaved == false){
									this.setState({ resetFees:true })
							}
							if(participantsSaved ==  false){
									this.setState({ resetParticipants:true })
							}
							break
            }                
        }
    }
    settingsDataSaved(dataSaved, settingTab) { 
			switch(settingTab) {
				case SettingsTabs.Dates:{
						this.setState({ datesSaved:dataSaved })
						break
				}
				case SettingsTabs.OilConditions:{
						this.setState({ oilSaved:dataSaved })
						break
				}
				case SettingsTabs.Setup:{
						this.setState({ setupSaved:dataSaved })
						break
				}
				case SettingsTabs.Divisions:{
						this.setState({ divisionsSaved:dataSaved })
						break
				}
				case SettingsTabs.Fees:{
						this.setState({ feesSaved:dataSaved })
						break
				}
				case SettingsTabs.Participants:{
						this.setState({ participantsSaved:dataSaved })
						break
				}
				case SettingsTabs.Template:{
						this.setState({ templateSaved:dataSaved })
						break
				}
			}
    }

    // Reset the reset flags if a reset was done
    datesResetDone(){
        this.setState({ resetDates:false })
    }
    oilResetDone(){
        this.setState({ resetOil:false })
    }
    setupResetDone(){
        this.setState({ resetSetup:false })
    }
    divisionsResetDone(){
        this.setState({ resetDivisions:false })
    }
    feesResetDone(){
        this.setState({ resetFees:false })
    }
    participantsResetDone(){
        this.setState({ resetParticipants:false })
    }
    templateResetDone(){
        this.setState({ resetTemplate:false })
    }
	
    render() {
			const {   seasonyears, seasonstatus,settingsseason, isNewSeason, newseason } = this.props
			const { resetDates,resetOil,resetSetup,resetDivisions,resetFees,resetParticipants,resetTemplate } = this.state
			
			let seasonId;
			let description;
			let isSeasonSet = true;
			let year;

			if(isNewSeason){
				seasonId = newseason.id,
				description = newseason.description,
				isSeasonSet = newseason.isSeasonSet;
				year = newseason.year;
			} else {	
				if(isEmpty(seasonstatus) === false) {
					const season = _.find(seasonstatus,{ id:settingsseason });
					seasonId = season.id;
					description = season.description;
					isSeasonSet = season.isSeasonSet;
					year = season.year;
				}
			}
			const seasonDateLabel = (isSeasonSet === true) ? 'Season Dates':'Setup Season'				
	
			return (
				<ContentWrapper>
					<div className="content-heading">Season Settings</div>
					<h5>Manage settings and default values used during event creation</h5>
					<hr/>
							<Row className="center-block center-text">
							<Col sm={9}>
							{								
                (isSeasonSet === false || isNewSeason) && (<TriggerSeason seasonId={seasonId} description={ description } year={year} /> )  
							}
							{ 
							(isSeasonSet === true && !isNewSeason) && (<PanelGroup accordion id="seasonsettings">
								<Panel eventKey={SettingsTabs.Dates}
									title = "Set season dates"
									header = {seasonDateLabel}
									collapsible 
									expanded={this.state.datesOpen}
									onSelect={this.handlePanelNavigation}
								>
									<SeasonDates triggerSeason = {this.triggerSeason} onSeasonChange={this.handleSelectedSeasonChanged} settingsSaved={this.settingsDataSaved} resetform={resetDates}  resetDone={this.datesResetDone} onAddSeason={this.handleAddSeason} />
								</Panel>
								{
									([<Panel eventKey={SettingsTabs.OilConditions}
									title = "Classify the governing Lanes oil ratios"
									header = "Lane Oil Conditions"
									collapsible
									expanded={this.state.oilOpen}
									onSelect={this.handlePanelNavigation}
									key='1'
									>
										<OilConditions  seasonyears={seasonyears}  settingsSaved={this.settingsDataSaved} resetform={resetOil} resetDone={this.oilResetDone} />
								</Panel>,                          
								<Panel eventKey={SettingsTabs.Setup}
									title = "Identify minimum number of games for league and tournament events. Set tournament location"
									header = "Setup"
									collapsible 
									expanded={this.state.setupOpen}
									onSelect={this.handlePanelNavigation}
									key='2'
								>
									<Setup  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetSetup} resetDone={this.setupResetDone}   />
								</Panel>, 
								<Panel eventKey={SettingsTabs.Divisions}
									title = "Identify available divisions for the season"
									header = "Divisions"
									collapsible 
									expanded={this.state.divisionsOpen}
									onSelect={this.handlePanelNavigation}
									key='3'
								>
                  <Divisions seasonyears={seasonyears} seasonId={seasonId} settingsSaved={this.settingsDataSaved} resetform={resetDivisions} resetDone={this.divisionsResetDone} />
								</Panel>,   
								<Panel eventKey={SettingsTabs.Fees}
									title = "Define event fees at the division level"
									header = "Fees"
									collapsible 
									expanded={this.state.feesOpen}
									onSelect={this.handlePanelNavigation}
									key='4'
								>
									<Fees seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetFees} resetDone={this.feesResetDone}   />
								</Panel>,          
								<Panel eventKey={SettingsTabs.Participants}
									title="Define minimum number of participating player requirements for league and tournament events"
									header = "Participants"
									collapsible
									expanded={this.state.participantsOpen}
									onSelect={this.handlePanelNavigation}
									key='5'
								>
									<Participant  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetParticipants}  resetDone={this.participantsResetDone}/>
								</Panel>,
								<Panel eventKey={SettingsTabs.Template}
									title = "Setup SendGrid email templates identifiers"
									header = "Email Settings"
									collapsible
									onSelect={this.handlePanelNavigation}
									key='6'
								>
									<Template  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetTemplate} resetDone={this.templateResetDone}/>
								</Panel>])
								}
							</PanelGroup>)

											}
									</Col>
							</Row>              
				</ContentWrapper>)
    }
}
SeasonSettings.propTypes = {
	dispatch:PropTypes.func,
	fetchActiveSeasons: PropTypes.func,
	seasonyears:PropTypes.string,
	settingsseason:PropTypes.number,
	defaultSeason: PropTypes.object,
	seasonstatus: PropTypes.array,
	oidc: PropTypes.object,
	isNewSeason: PropTypes.bool,
	newseason: PropTypes.object
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const seasonyears = selector(state,'seasonyears')
	const settingsseason = selector(state,'settingsseason') 
	const defaultSeason = selector(state,'defaultSeason') 
	const seasonstatus = selector(state,'seasonstatus') 
	const isNewSeason = selector(state, 'isNewSeason')
	const newseason = selector(state, 'newseason')
  return {
		seasonyears, 
		settingsseason,
		defaultSeason,
		seasonstatus,
		isNewSeason,
		newseason
	}

}
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		fetchActiveSeasons,
		fetchNewSeason
	},dispatch)
}
export default reduxForm({
  form:formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(SeasonSettings))




// WEBPACK FOOTER //
// ./src/containers/season/index.js